import {inject, Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {MasterDataService} from '../master-data/master-data-service';
import {FormType} from '../master-data/master-data.model';

@Injectable({
  providedIn: 'root'
})
export class FormTypesResolver {
  private masterDataService = inject(MasterDataService);


  getFormTypes(): Observable<FormType[]> {
    return this.masterDataService.getFormTypes();
  }
}


export const fromTypesResolver: ResolveFn<FormType[]> =
  (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    return inject(FormTypesResolver).getFormTypes();
  };
